import * as React from 'react'

type Announce = (message: string) => void

type Announcement = { slot: 0 | 1; message: string }

const AnnouncerContext = React.createContext<Announce | null>(null)

function nextAnnouncement(previous: Announcement, message: string): Announcement {
  return { slot: previous.slot === 0 ? 1 : 0, message }
}

export function AnnouncerProvider({ children }: { children: React.ReactNode }) {
  const [announcement, announce] = React.useReducer(nextAnnouncement, {
    slot: 0,
    message: '',
  })

  return (
    <AnnouncerContext.Provider value={announce}>
      {children}
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {announcement.slot === 0 ? announcement.message : ''}
      </div>
      <div aria-live="polite" aria-atomic="true" className="sr-only">
        {announcement.slot === 1 ? announcement.message : ''}
      </div>
    </AnnouncerContext.Provider>
  )
}

export function useAnnounce(): Announce {
  const announce = React.useContext(AnnouncerContext)
  if (!announce) {
    throw new Error('useAnnounce must be used within an AnnouncerProvider')
  }
  return announce
}
